import Provider from "../enum/Provider.enum";

export const OPEN_ACCOUNT_STATUS = 10013;

const ACCOUNT_OPENING_LINKS: Partial<Record<Provider, string>> = {
  [Provider.BELARUS]: "https://tradernet.by",
  [Provider.UAE]: "https://tradernet.ae",
  [Provider.ARMENIA]: "https://tradernet.am",
  [Provider.DEFAULT]: "https://tradernet.by",
  [Provider.TFOS]: "https://trade.tfos.com",
};

export const hasOpenAccount = (status?: number | null) =>
  status === OPEN_ACCOUNT_STATUS;

export const getAccountOpeningLink = (provider: Provider) =>
  ACCOUNT_OPENING_LINKS[provider] ?? "";
